export default __webpack_public_path__ + "static/media/animal-btn-2.d3eb08ef.jpg";